import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { MeasurementStandard } from '../models/measurement-standard';

@Injectable({
  providedIn: 'root'
})
export class MeasurementStandardService extends BaseService<MeasurementStandard> {

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string        
  ) { 
    super(http,rootUrl,'Plasard/Measurements/Standard');
  }
}
